var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"table-basic-info"}},[_c('el-table',{staticStyle:{"width":"100%","margin":"20px 0 30px","height":"100%"},attrs:{"data":_vm.data}},[_c('el-table-column',{attrs:{"prop":"key","label":"Configuration Item","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Value"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c53ab8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/tables/detail/info/_table_basic_info.vue
// module id = null
// module chunks = 